import styles from "../styles.module.scss";

export default function SuperOffer(props) {

    return window.scs_black_friday_2025 ? <>
        <h4 className={`${styles.bf_heading}`}>{`${window.scs_black_friday_2025_h1}`}</h4>
        {/*<ul className={`${styles.list_items}`}>*/}
        {/*    <li>2 Seat gap Fillers</li>*/}
        {/*    <li>Seat Cover Care Kit (2 Cleaners & Towel)</li>*/}
        {/*    <li>Matching Steering Wheel Cover</li>*/}
        {/*    <li>Extended Warranty</li>*/}
        {/*</ul>*/}
        <div className={`${styles.bf_wrapper}`}>
            <h5 dangerouslySetInnerHTML={{__html: `${window.scs_black_friday_2025_h2}`}}></h5>
            <ul className={`${styles.bf_items}`}>
                <li>
                    <div className={`${styles.img_wrapper}`}>
                        <img src={`${window.scs_promo_bonus_1_img}`} alt={`${window.scs_promo_bonus_1_alt}`}/>
                    </div>
                    <strong dangerouslySetInnerHTML={{__html: `${window.scs_promo_bonus_1_title}`}}></strong>
                    <span>MSRP: <s>{window.scs_promo_bonus_1_price}</s></span>
                </li>
                <li>
                    <div className={`${styles.img_wrapper}`}>
                        <img src={`${window.scs_promo_bonus_2_img}`} alt={`${window.scs_promo_bonus_2_alt}`}/>
                    </div>
                    <strong dangerouslySetInnerHTML={{__html: `${window.scs_promo_bonus_2_title}`}}></strong>
                    <span>MSRP: <s>{window.scs_promo_bonus_2_price}</s></span>
                </li>
                <li>
                    <div className={`${styles.img_wrapper}`}>
                        <img src={`${window.scs_promo_bonus_3_img}`} alt={`${window.scs_promo_bonus_3_alt}`}/>
                    </div>
                    <strong dangerouslySetInnerHTML={{__html: `${window.scs_promo_bonus_3_title}`}}></strong>
                    <span>MSRP: <s>{window.scs_promo_bonus_3_price}</s></span>
                </li>
                <li>
                    <div className={`${styles.img_wrapper}`}>
                        <img src={`${window.scs_promo_bonus_4_img}`} alt={`${window.scs_promo_bonus_4_alt}`}/>
                    </div>
                    <strong dangerouslySetInnerHTML={{__html: `${window.scs_promo_bonus_4_title}`}}></strong>
                    <span>MSRP: <s>{window.scs_promo_bonus_4_price}</s></span>
                </li>
            </ul>
        </div>
        <h6 className={`${styles.bf_choose_heading}`}><span>Choose Your Setup</span></h6>

    </> : '';
}